import Spinner from "components/Spinner";
import { useAppSelector } from "store/hooks";

const ZoomSpan = ({ zoomValue }: { zoomValue: number }) => {
  const tiles_loaded = useAppSelector(
    ({ slideTiles }) => slideTiles.tiles_loaded
  );

  return (
    <span className="ControlButtons__zoom">
      {tiles_loaded ? (
        <>{zoomValue}&times;</>
      ) : (
        <Spinner
          size="16px"
          width="3px"
          frontColor="var(--teal)"
          backColor="var(--blue15)"
        />
      )}
    </span>
  );
};

export default ZoomSpan;
